module.exports = __webpack_public_path__ + "2dbad39b6819ac4f74ae27ac2a66f31c.pdf";